export type MeetingEnv = 'development' | 'test' | 'production';

export const MEETING_HOSTS = {
  development: 'hkmeeting.net',
  test: 'hkmeeting.org',
  production: 'hkmeeting.ai',
} as const;

export function getMeetingEnvByHostname(hostname: string): MeetingEnv {
  if (!hostname || hostname === 'localhost' || hostname.endsWith('.local')) {
    return 'development';
  }

  if (hostname === MEETING_HOSTS.production) {
    return 'production';
  }

  if (hostname === MEETING_HOSTS.test) {
    return 'test';
  }

  return 'development';
}

export function getMeetingHostByEnv(env: MeetingEnv): string {
  return MEETING_HOSTS[env];
}
